//
// Autogenerated by Thrift Compiler (0.7.0-en-11139b3b5cb61e817408c6e84b0e1c258bf6c6ae)
//
// DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
//


  // Define types and services

  var Thrift = require('evernote-thrift').Thrift;

  module.exports.CommEnginePlacement = {
    'FULLSCREEN' : 0,
    'BANNER' : 1,
    'CARD' : 2
  };

  module.exports.CommEnginePriority = {
    'IMMEDIATE' : 0,
    'SUITABLE' : 1
  };

  module.exports.CommEngineEventType = {
    'SHOW' : 0,
    'DISMISS' : 1,
    'TRACK' : 2,
    'ERROREVENT' : 3
  };

  module.exports.CommEngineClientType = {
    'MAC' : 0,
    'WINDOWS' : 1,
    'IOS' : 2,
    'ANDROID' : 3,
    'WEB' : 4,
    'CLIPPER' : 5,
    'ION' : 6
  };

  module.exports.Event = Thrift.Struct.define('Event',  {
    1: { alias: 'type', type: Thrift.Type.I32 },
    2: { alias: 'timeOccurred', type: Thrift.Type.I64 },
    3: { alias: 'messageKey', type: Thrift.Type.STRING },
    4: { alias: 'label', type: Thrift.Type.STRING }
  });

  module.exports.MessageContent = Thrift.Struct.define('MessageContent',  {
    1: { alias: 'templateUri', type: Thrift.Type.STRING },
    2: { alias: 'contentVariablesJson', type: Thrift.Type.STRING }
  });

  module.exports.InAppMessage = Thrift.Struct.define('InAppMessage',  {
    1: { alias: 'key', type: Thrift.Type.STRING },
    2: { alias: 'priority', type: Thrift.Type.I32 },
    3: { alias: 'content', type: Thrift.Type.STRUCT, def: module.exports.MessageContent },
    4: { alias: 'placement', type: Thrift.Type.I32 },
    5: { alias: 'offline', type: Thrift.Type.BOOL },
    6: { alias: 'expires', type: Thrift.Type.I64 }
  });

  module.exports.InAppMessageIdentifier = Thrift.Struct.define('InAppMessageIdentifier',  {
    1: { alias: 'key', type: Thrift.Type.STRING }
  });

  module.exports.Config = Thrift.Struct.define('Config',  {
    1: { alias: 'cooldownPeriodMillis', type: Thrift.Type.I64 }
  });

  module.exports.AnalyticsEvent = Thrift.Struct.define('AnalyticsEvent',  {
    1: { alias: 'category', type: Thrift.Type.STRING },
    2: { alias: 'action', type: Thrift.Type.STRING },
    3: { alias: 'label', type: Thrift.Type.STRING }
  });

  module.exports.MessageResponse = Thrift.Struct.define('MessageResponse',  {
    1: { alias: 'messages', type: Thrift.Type.LIST, def: Thrift.List.define(Thrift.Type.STRUCT, module.exports.InAppMessage)  },
    2: { alias: 'messageRequestGuid', type: Thrift.Type.STRING },
    3: { alias: 'config', type: Thrift.Type.STRUCT, def: module.exports.Config }
  });

  module.exports.MessageRequest = Thrift.Struct.define('MessageRequest',  {
    1: { alias: 'guid', type: Thrift.Type.STRING },
    2: { alias: 'knownMessages', type: Thrift.Type.LIST, def: Thrift.List.define(Thrift.Type.STRUCT, module.exports.InAppMessageIdentifier)  },
    3: { alias: 'supportedPlacements', type: Thrift.Type.LIST, def: Thrift.List.define(Thrift.Type.I32)  },
    4: { alias: 'events', type: Thrift.Type.LIST, def: Thrift.List.define(Thrift.Type.STRUCT, module.exports.Event)  },
    5: { alias: 'locale', type: Thrift.Type.STRING },
    6: { alias: 'commEngineJsVersion', type: Thrift.Type.I32 },
    7: { alias: 'nativeClientVersion', type: Thrift.Type.I32 },
    8: { alias: 'clientType', type: Thrift.Type.I32 },
    9: { alias: 'uiLanguage', type: Thrift.Type.STRING }
  });

  module.exports.DebugParams = Thrift.Struct.define('DebugParams',  {
    1: { alias: 'apiLogging', type: Thrift.Type.BOOL },
    2: { alias: 'dataLogging', type: Thrift.Type.BOOL },
    3: { alias: 'stateLogging', type: Thrift.Type.BOOL },
    4: { alias: 'syncLogging', type: Thrift.Type.BOOL },
    5: { alias: 'frequentSyncs', type: Thrift.Type.BOOL },
    6: { alias: 'cooldownPeriodMillis', type: Thrift.Type.I64 },
    7: { alias: 'alwaysProcessServerResponse', type: Thrift.Type.BOOL }
  });

  module.exports.InitializeRequest = Thrift.Struct.define('InitializeRequest',  {
    1: { alias: 'clientType', type: Thrift.Type.I32 },
    2: { alias: 'supportedPlacements', type: Thrift.Type.LIST, def: Thrift.List.define(Thrift.Type.I32)  },
    3: { alias: 'savedState', type: Thrift.Type.BINARY },
    4: { alias: 'locale', type: Thrift.Type.STRING },
    5: { alias: 'nativeClientVersion', type: Thrift.Type.I32 },
    6: { alias: 'debugParams', type: Thrift.Type.STRUCT, def: module.exports.DebugParams },
    7: { alias: 'uiLanguage', type: Thrift.Type.STRING }
  });

  module.exports.ShowRequest = Thrift.Struct.define('ShowRequest',  {
    1: { alias: 'placement', type: Thrift.Type.I32 },
    2: { alias: 'html', type: Thrift.Type.STRING },
    3: { alias: 'priority', type: Thrift.Type.I32 }
  });

